import React, { useEffect, useRef, useState } from "react";
import { Box, Table, TableCell, TableRow, Typography, useMediaQuery } from "@mui/material";
import { ArrowDown, ArrowUp } from "assets";
import { tablet } from "utils";

export const CreditworthinessRating = ({ score, ppd, companyName }) => {
  const matchesTablet = useMediaQuery(tablet);

  const config = [
    {
      title: "Bankroto tikimybė",
      row: ["100% - 17.36%", "17.35% - 5.69%", "5.68% - 1.70%", "1.69% - 0.50%", "0.49% - 0.00%"],
      values: [
        { maxval: "100", minval: "17.36" },
        { maxval: "17.35", minval: "5.69" },
        { maxval: "5.68", minval: "1.70" },
        { maxval: "1.69", minval: "0.50" },
        { maxval: "0.49", minval: "0.00" },
      ],
    },
    {
      title: "Kreditingumas",
      row: [
        "200 - 500 Žemiausias",
        "501 - 560 Žemas",
        "561 - 620 Vidutinis",
        "621 - 680 Aukštas",
        "681 - 800 Aukščiausias",
      ],
      values: [
        { minval: "200", maxval: "500" },
        { minval: "501", maxval: "560" },
        { minval: "561", maxval: "620" },
        { minval: "621", maxval: "680" },
        { minval: "681", maxval: "800" },
      ],
    },
    {
      title: "Įmonių dalis",
      row: ["1%", "13%", "38%", "36%", "12%"],
    },
  ];

  const [left, setleft] = useState(122);
  const [right, setright] = useState(-1);

  const calculateArrowLocationLeft = (trElement) => {
    if (score) {
      const tds = trElement.current.getElementsByTagName("td");
      if (tds) {
        let arrowPosition = 0;

        for (const item of tds) {
          if (item.getAttribute("minval")) {
            const minVal = +item.getAttribute("minval");
            const maxVal = +item.getAttribute("maxval");
            if (score >= maxVal) {
              arrowPosition += item.clientWidth;
            } else if (score < maxVal && score >= minVal) {
              arrowPosition += Math.round((item.clientWidth * (score - minVal)) / (maxVal - minVal));
            }
          }
        }
        setleft(arrowPosition - 10);
      }
    }
  };

  const calculateArrowLocationRight = (trElement) => {
    if (ppd !== null) {
      const tds = trElement.current.getElementsByTagName("td");

      if (tds) {
        let arrowPosition = 0;
        for (const item of tds) {
          if (item.getAttribute("minval")) {
            const minVal = +item.getAttribute("minval");
            const maxVal = +item.getAttribute("maxval");
            if (ppd <= minVal) {
              arrowPosition += item.clientWidth;
            } else if (ppd > minVal && ppd <= maxVal) {
              arrowPosition += Math.round((item.clientWidth * (maxVal - ppd)) / (maxVal - minVal));
            }
          }
        }
        setright(trElement.current.clientWidth - arrowPosition - 11);
      }
    }
  };

  const riskScoreElement = useRef();
  const riskScoreElement2 = useRef();
  useEffect(() => {
    function handleResize() {
      calculateArrowLocationLeft(riskScoreElement);
      calculateArrowLocationRight(riskScoreElement2);
    }
    calculateArrowLocationLeft(riskScoreElement);
    calculateArrowLocationRight(riskScoreElement2);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box
        sx={{
          overflow: matchesTablet ? "auto" : "initial",
          "::-webkit-scrollbar": {
            height: "5px",
            // display: "none",
          },
        }}
      >
        <Box sx={{ width: "100%", display: "table", tableLayout: "fixed" }}>
          <Box
            sx={{
              width: "100%",
              minWidth: "720px",
            }}
          >
            <Box
              sx={{
                marginRight: `${right}px`,
                textAlign: "right",
              }}
            >
              <Box>
                <Typography textAlign="center" variant="caption">
                  {companyName}
                </Typography>
              </Box>
              <ArrowDown />
            </Box>

            <Table
              size="small"
              sx={{
                "tr:last-child": {
                  td: {
                    borderBottom: "none",
                  },
                },
              }}
            >
              {config.map(({ title, row, values }) => (
                <TableRow
                  ref={
                    title === "Kreditingumas"
                      ? riskScoreElement
                      : title === "Bankroto tikimybė"
                      ? riskScoreElement2
                      : null
                  }
                >
                  <TableCell
                    minval={title === "Kreditingumas" ? "0" : title === "Bankroto tikimybė" ? "101" : null}
                    maxval={title === "Kreditingumas" ? "200" : title === "Bankroto tikimybė" ? "102" : null}
                    sx={{
                      borderBottom: "none",
                      p: 0,
                      color: (theme) => theme.palette.speedometer.blue.main,
                      fontWeight: 500,
                      minWidth: "8rem",
                    }}
                  >
                    {title}
                  </TableCell>

                  {row.map((element, i) => (
                    <TableCell
                      minVal={values?.[i]?.minval}
                      maxVal={values?.[i]?.maxval}
                      sx={{
                        padding: "8px 0 8px 6px",
                        fontSize: "12px",
                        borderLeft: "0.5px solid #ACACAC",
                        borderBottom: "0.5px solid #ACACAC",
                      }}
                    >
                      {element}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </Table>
            <Box
              sx={{
                marginLeft: `${left}px`,
              }}
            >
              <ArrowUp color="#bdbec1" />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};
